import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Star, ImageOff } from "lucide-react";
import { GetImageUrl } from "../helpers/GetImageUrl";

// const API_BASE =
//   import.meta.env.VITE_API_BASE || "https://api.suraksha24x7.com";
const API_BASE = "http://localhost:9398";

export default function ProductCard({
  item,
  className = "",
}) {

  const image = item?.images?.[0]?.url ? GetImageUrl(item.images[0].url) : null;
  const productBasePath =
    item?.catalogType === "ip-network" ||
    item?.ipNetworkCategory ||
    item?.ipNetworkSubCategory
      ? "/it-products"
      : "/security-product";


  return (
    <Link
      to={`${productBasePath}/${item.slug}`}
      className={`group block h-full ${className}`}
    >
      <article
        className="
        h-full
        flex
        flex-col
        bg-white
        rounded
        border border-slate-300
        overflow-hidden
        transition-all duration-300
        "
      >
        {/* IMAGE */}

        <div className="relative aspect-[4/3] w-full bg-slate-100 overflow-hidden">
          {/* BADGES */}

          <div
            className="
  absolute
  top-3
  left-3
  right-3
  z-10
  flex
  justify-between
  items-start
  gap-2
  "
          >
            {item?.isTrending ? (
              <span
                className="
      inline-flex
      items-center
      gap-1.5
      px-3
      py-1.5
      rounded-full
      bg-white/95
      backdrop-blur-md
      text-[10px]
      sm:text-xs
      font-semibold
      text-blue-700
      shadow-md
      border
      border-blue-100
      "
              >
                <Star size={12} fill="currentColor" />
                Trending
              </span>
            ) : (
              <span />
            )}
          </div>

          <div
            className="
            absolute
            inset-0
            flex
            items-center
            justify-center
            p-2
            "
          >
            {image ? (
              <img
                src={image}
                alt={item.title}
                loading="lazy"
                decoding="async"
                className="
                max-w-full
                max-h-full
                w-auto
                h-auto
                object-contain
                object-center
                "
                onError={(e) => {
                  e.target.src = "https://placehold.co/600x400?text=No+Image";
                }}
              />
            ) : (
              <div className="h-full flex items-center justify-center">
                <ImageOff size={34} className="text-slate-300" />
              </div>
            )}
          </div>
        </div>

        {/* CONTENT */}

        <div
          className="
          flex
          flex-col
          flex-1
          p-3
          sm:p-4
          "
        >
          {/* BRAND */}
          <div
            className="
    mb-1
    text-[11px]
    sm:text-xs
    font-semibold
    uppercase
    tracking-wide
    text-blue-600
  "
          >
            {item.brand?.brandName || item.ipNetworkBrand?.brandName || "Brand"}
          </div>

          {/* TITLE */}
          <h1
            className="
    text-sm
    sm:text-base
    font-bold
    text-slate-900
    leading-snug
    line-clamp-2
    min-h-[44px]
    group-hover:text-blue-700
    transition-colors
  "
          >
            {item.title}
          </h1>

          {/* DESCRIPTION */}

          <p
            className="
    mt-2
    text-xs
    sm:text-sm
    text-slate-500
    leading-relaxed
    line-clamp-2
    min-h-[38px]
  "
          >
            Product description goes here
          </p>

          {/* FOOTER */}

          <div
            className="
    mt-auto
    pt-3
    flex
    items-center
    justify-between
    border-t
    border-slate-200
  "
          >
            <span
              className="
      text-xs
      sm:text-sm
      font-semibold
      text-blue-700
      transition
    "
            >
              View Details
            </span>

            <div
              className="
      flex
      items-center
      gap-1
      text-xs
      sm:text-sm
      font-medium
      text-slate-500
      group-hover:text-blue-700
      transition
    "
            >
              Explore
              <ArrowRight size={15} />
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
}
